import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTheme } from '../../utils/useTheme';
export const ResizeLeftRightIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => {
  const $ = _c(6);
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.tokens.foreground.main.primary) {
    t0 = <path d="M17.9531 8.00879C18.3378 8.04741 18.6798 8.21879 18.9482 8.49023L21.5205 11.0898C21.827 11.3999 22 11.8027 22 12.25C22 12.6973 21.827 13.1001 21.5205 13.4102L18.9482 16.0098C18.6415 16.3199 18.2387 16.4999 17.7861 16.5C17.3334 16.5 16.9299 16.32 16.623 16.0098C16.3165 15.6997 16.1426 15.297 16.1426 14.8496V14.5498H7.85742V14.8496C7.85742 15.297 7.68355 15.6997 7.37695 16.0098C7.07011 16.32 6.66659 16.5 6.21387 16.5C5.76131 16.4999 5.3585 16.3199 5.05176 16.0098L2.47949 13.4102C2.17299 13.1001 2 12.6973 2 12.25C2 11.8027 2.17299 11.3999 2.47949 11.0898L5.05176 8.49023L5.1709 8.37988C5.45977 8.13774 5.81788 8.0001 6.21387 8C6.66659 8 7.07011 8.17998 7.37695 8.49023C7.68355 8.80027 7.85742 9.20301 7.85742 9.65039V9.9502H16.1426V9.65039C16.1426 9.203 16.3165 8.80026 16.623 8.49023L16.7422 8.37988C17.0312 8.13761 17.3899 8 17.7861 8L17.9531 8.00879Z" fill={theme.tokens.foreground.main.primary} stroke={theme.tokens.foreground.main.primary} strokeWidth="1" />;
    $[0] = theme.tokens.foreground.main.primary;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== ref || $[4] !== t0) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});
export default ResizeLeftRightIcon;